// src/pages/xray/XrayLobby/TabUserCommands.js
import React from 'react';

const TabUserCommands = ({
  selectedUserCOMMANDS,
  setSelectedUserCOMMANDS,
  userCommandsLimits,
}) => {
  return (
    <>
      <div className="tabs mt-6 flex border-b">
        {['USR CMD'].map((label, index) => (
          <label
            key={index}
            className={`cursor-pointer px-2 py-1 border-t border-r border-l border-red-600 bg-red-300 ml-1 rounded-t-md ${
              selectedUserCOMMANDS === `userCOMMANDS${index + 1}`
                ? 'border-b-0 font-bold'
                : 'border-red-600 bg-red-600 hover:bg-red-700 transition-colors duration-200 text-white'
            }`}
          >
            <input
              type="radio"
              className="hidden"
              name="tabs-group"
              checked={selectedUserCOMMANDS === `userCOMMANDS${index + 1}`}
              onChange={() =>
                setSelectedUserCOMMANDS(`userCOMMANDS${index + 1}`)
              }
            />
            {label}
          </label>
        ))}
      </div>

      <div className="px-6 py-2 bg-white shadow-lg rounded-lg">
        {selectedUserCOMMANDS === 'userCOMMANDS1' && (
          <div>
            <h1 className="font-bold text-2xl p-2">USER COMMANDS</h1>
            <pre className="bg-gray-100 p-4 rounded-md border">
              {userCommandsLimits || 'No User Entered Commands available'}
            </pre>
          </div>
        )}
      </div>
    </>
  );
};

export default TabUserCommands;
